export const SUB_NONE = 'none';
export const SUB_TRIALING = 'trialing';
export const SUB_ACTIVE = 'active';
export const SUB_SCHEDULED_TO_CANCEL = 'scheduled_to_cancel';
export const SUB_PAST_DUE = 'past_due';
export const SUB_PAUSED = 'paused';

